import { render } from "./InfoPopup.vue?vue&type=template&id=3ee88b98&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=ts"
export * from "./InfoPopup.vue?vue&type=script&lang=ts"

import "./InfoPopup.vue?vue&type=style&index=0&id=3ee88b98&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-3ee88b98"

export default script